import { YandexPayWidget } from '@screens/Product/ui/YandexPayWidget/YandexPayWidget';
import { ID_REMAINDER_ATTRIBUTE, ID_SEO_NAME_ATTRIBUTE } from '@shared/constants/keys';
import { useAppSelector } from '@shared/hooks/redux';
import { ProductRatingType } from '@shared/types/product';
import { ProductRemainder } from '@shared/ui/ProductRemainder/ProductRemainder';
import { formatPrice } from '@shared/utils/formatPrice/formatPrice';
import { ProductReviewsSummary } from '@widgets/ProductReviewsSummary';

import { Article } from './Article/Article';
import { Benefits } from './Benefits/Benefits';
import { Chars } from './Chars/Chars';
import { Controls } from './Controls/Controls';
import { MarketplaceLinks } from './MarketplaceLinks/MarketplaceLinks';
import cls from './Information.module.scss';

type InformationProps = {
  rating?: ProductRatingType;
};

export const Information = ({ rating }: InformationProps) => {
  const name = useAppSelector((state) => state.product.data.name);
  const retailPrice = useAppSelector((state) => state.product.data.retailPrice);
  const props = useAppSelector((state) => state.product.data.props);

  const remainder = props[ID_REMAINDER_ATTRIBUTE]?.values[0]?.value;
  const seoName = props[ID_SEO_NAME_ATTRIBUTE]?.values[0]?.value;

  const correctName = seoName || name;

  return (
    <div className={cls.wrap}>
      <ProductReviewsSummary
        className={cls.reviewsSummary}
        rating={rating}
      />
      {correctName && <h1 className={cls.title}>{correctName}</h1>}

      <Article />
      <ProductRemainder
        className={cls.remainder}
        remainder={remainder}
      />

      <div className={cls.price}>{formatPrice(retailPrice)}</div>
      <YandexPayWidget price={retailPrice} />
      <Controls />
      <Benefits />
      <MarketplaceLinks />
      <Chars />
    </div>
  );
};
